import React from 'react';

interface LeftArrowDoubleIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const LeftArrowDoubleIcon: React.FC<LeftArrowDoubleIconProps> = ({ 
  width = 24, 
  height = 24, 
  color = '#989898',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <path 
        d="M10.5781 7.57613C10.8124 7.34181 11.1914 7.34181 11.4257 7.57613C11.6601 7.81044 11.6601 8.18947 11.4257 8.42378L7.84956 12L11.4257 15.5761C11.6601 15.8104 11.6601 16.1895 11.4257 16.4238C11.1914 16.6581 10.8124 16.6581 10.5781 16.4238L6.57808 12.4238C6.34377 12.1895 6.34377 11.8104 6.57808 11.5761L10.5781 7.57613ZM16.5781 7.57613C16.8124 7.34181 17.1914 7.34181 17.4257 7.57613C17.6601 7.81044 17.6601 8.18947 17.4257 8.42378L13.8496 12L17.4257 15.5761C17.6601 15.8104 17.6601 16.1895 17.4257 16.4238C17.1914 16.6581 16.8124 16.6581 16.5781 16.4238L12.5781 12.4238C12.3438 12.1895 12.3438 11.8104 12.5781 11.5761L16.5781 7.57613Z" 
        fill={color}
      />
    </svg>
  );
};

export default LeftArrowDoubleIcon;

